import React, { useEffect, useReducer, useState } from "react";
import {
  agreedProductsByMallId,
  mallEntriesByProductId,
  mallEntryById,
  productComplianceStatemanage,
  productComplinaceintialState,
} from "../data";
import Grid from "@mui/material/Grid2";
import DashboardLayout from "../../../../../layoutcontainers/DashboardLayout";
import MaterialBox from "../../../../../components/MaterialBox";
import {
  Card,
  CardContent,
  CardHeader,
  FormControl,
  FormHelperText,
  IconButton,
  Stack,
} from "@mui/material";
import MaterialTypography from "../../../../../components/MaterialTypography";
import MaterialInput from "../../../../../components/MaterialInput";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuthData } from "../../../../context/loginContext/LoginContextProvider";
import MaterialSelect from "../../../../../components/MasterSelect";
import MaterialButton from "../../../../../components/MaterialButton";
import request from "graphql-request";
import BASEURL from "../../../../../pages/Utils/Baseurl";
import { allProducts, allUsers } from "../../api/query";
import AddCircleOutlinedIcon from "@mui/icons-material/AddCircleOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import { apicall } from "../../../../../Integration/apicall";
import { createMallEntry, updatemall } from "../../api/mutation";
import { useLoading } from "../../../../../context/LodingContext";
import Swal from "sweetalert2";

const ProductDisplayComplianceForm = () => {
  const [productCompliancedata, dispatch] = useReducer(
    productComplianceStatemanage,
    productComplinaceintialState
  );
  const [inputDisble, setInputDisble] = useState(false);
  const [allagentsOptions, setAllagentsOptions] = useState([]);
  const [allProductsOptions, setAllProductsOptions] = useState([]);

  const navigate = useNavigate();
  const location = useLocation();
  const { type, id } = location.state || {};
  const { userId } = useAuthData();
  const { setCirleLoading } = useLoading();

  useEffect(() => {
    fetchallusers();
    fetchallproducts();
  }, []);
  useEffect(() => {
    if (type === "view") {
      setInputDisble(true);
    } else {
      setInputDisble(false);
    }
  }, [type]);

  useEffect(() => {
    if (id) {
      fetchMallById(id);
    }
  }, [id]);

  const fetchallusers = async () => {
    try {
      const response = await request(BASEURL, allUsers);
      console.log(response, "response");

      if (response.allUsers) {
        let allagents = response.allUsers;
        allagents = allagents.map((agent) => ({
          value: agent?.employeeCode,
          label: agent?.employeeName,
          rowid: agent?.id,
          role: agent?.role?.id,
        }));
        setAllagentsOptions(allagents);
      }
    } catch (error) {
      setAllagentsOptions([]);
    }
  };

  const fetchallproducts = async () => {
    const response = await apicall(allProducts);
    if (response.success) {
      const success = response?.data?.data?.allProducts?.success;
      let data = response?.data?.data?.allProducts?.data;
      const message = response?.data?.data?.allProducts?.message;
      if (success) {
        data = data.map((row) => {
          const name = row?.productName || "";
          const code = row?.productCode || "";
          const label = code ? `${name} (${code})` : name;
          return {
            value: row?.productCode,
            label: label,
            category: row?.productCategory,
            rowid: row?.id,
            productName: name,
            productCode: code,
          };
        });
        setAllProductsOptions(data);
      } else {
        alert("cannot fetch agents");
      }
    }
  };

  const Addproducts = () => {
    dispatch({ action: "add" });
  };

  const deleteproducts = (index) => {
    dispatch({ index, action: "delete" });
  };

  const handleSumbit = async () => {
    setCirleLoading(true);
    try {
      const value = {
        agentId: productCompliancedata.agentId.rowid,
        userId: userId,
        roleId: productCompliancedata.agentId.role,
        marketName: productCompliancedata.marketName,
        address: productCompliancedata.address,
        contactPerson: productCompliancedata.contactPerson,
        contactNumber: productCompliancedata.contactNumber,
        contractStart: productCompliancedata.contractStart,
        contractEnd: productCompliancedata.contractEnd,
        completeWithin: productCompliancedata.completeWithin,
        products: productCompliancedata.products.map((product) => ({
          productId: product?.productId.rowid,
          quantity: Number(product?.quantity),
          productCategory: product?.productCategory,
        })),
      };
      const response = await request(BASEURL, createMallEntry, {
        input: value,
      });
      const success = response?.createMallEntry?.success;
      const message = response?.createMallEntry?.message;
      if (success) {
        Swal.fire({
          position: "top",
          icon: "success",
          title: message,
          showConfirmButton: true,
        }).then(() => {
          navigate("/product-compliance");
        });
      }
    } catch (error) {
    } finally {
      setCirleLoading(false);
    }
  };

  const fetchMallById = async (id) => {
    try {
      const response = await request(BASEURL, mallEntryById, {
        id: parseInt(id),
      });

      const data = response?.mallEntryById;

      if (data) {
        dispatch({ value: data?.marketName, name: "marketName" });
        dispatch({ value: data?.contactPerson, name: "contactPerson" });
        dispatch({ value: data?.contactNumber, name: "contactNumber" });
        dispatch({ value: data?.contractStart, name: "contractStart" });
        dispatch({ value: data?.contractEnd, name: "contractEnd" });
        dispatch({ value: data?.completeWithin, name: "completeWithin" });
        dispatch({ value: data?.address, name: "address" });
        dispatch({
          value: {
            value: data?.agent?.employeeCode,
            label: data?.agent?.employeeName,
            rowid: data?.agent?.id,
            role: data?.role?.id,
          },
          name: "agentId",
        });

        data?.agreedProducts?.map((v, index) => {
          const name = v?.product?.productName || "";
          const code = v?.product?.productCode || "";
          const label = code ? `${name} (${code})` : name;
          dispatch({
            value: {
              value: v?.product?.productCode,
              label: label,
              category: v?.product?.productCategory,
              rowid: v?.product?.id,
              productName: name,
              productCode: code,
            },
            name: "products",
            index,
            field: "productId",
          });
          dispatch({
            value: v?.quantity,
            name: "products",
            index,
            field: "quantity",
          });
        });
      }
    } catch (error) {
    } finally {
    }
  };

  const handleUpdate = async () => {
    setCirleLoading(true);
    try {
      const value = {
        agentId: productCompliancedata.agentId.rowid,
        userId: userId,
        roleId: productCompliancedata.agentId.role,
        marketName: productCompliancedata.marketName,
        address: productCompliancedata.address,
        contactPerson: productCompliancedata.contactPerson,
        contactNumber: productCompliancedata.contactNumber,
        contractStart: productCompliancedata.contractStart,
        contractEnd: productCompliancedata.contractEnd,
        completeWithin: productCompliancedata.completeWithin,
        products: productCompliancedata.products.map((product) => ({
          productId: product?.productId.rowid,
          quantity: Number(product?.quantity),
          productCategory: product?.productCategory,
        })),
      };
      const response = await request(BASEURL, updatemall, {
        id: id,
        input: value,
      });
      const success = response?.updateMallEntry?.success;
      const message = response?.updateMallEntry?.message;
      if (success) {
        Swal.fire({
          position: "top",
          icon: "success",
          title: message,
          showConfirmButton: true,
        }).then(() => {
          navigate("/product-compliance");
        });
      }
    } catch (error) {
    } finally {
      setCirleLoading(false);
    }
  };
  return (
    <DashboardLayout>
      <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="column" spacing={0}>
                <MaterialTypography variant="h5" fontWeight="medium">
                  {type == "add" ? "Add" : type == "edit" ? "Edit" : "View"}{" "}
                  Product Compliance
                </MaterialTypography>
              </Stack>
            </Stack>
          }
        />
        <CardContent sx={{ minHeight: "70vh" }}>
          <MaterialBox>
            <Grid container spacing={2}>
              <Grid size={{ lg: 3, xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Market Name <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  value={productCompliancedata?.marketName}
                  name="marketName"
                  placeholder="Enter marketName"
                  disabled={inputDisble}
                  onChange={(e) =>
                    dispatch({ value: e?.target?.value, name: "marketName" })
                  }
                  error={
                    productCompliancedata.marketNameStatus === "error"
                      ? true
                      : false
                  }
                  success={
                    productCompliancedata.marketNameStatus === "success"
                      ? true
                      : false
                  }
                />
              </Grid>
              <Grid size={{ lg: 3, xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Contact Person <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  value={productCompliancedata?.contactPerson}
                  name="contactPerson"
                  placeholder="Enter contactPerson"
                  disabled={inputDisble}
                  onChange={(e) =>
                    dispatch({ value: e?.target?.value, name: "contactPerson" })
                  }
                  error={
                    productCompliancedata.contactPersonStatus === "error"
                      ? true
                      : false
                  }
                  success={
                    productCompliancedata.contactPersonStatus === "success"
                      ? true
                      : false
                  }
                />
              </Grid>
              <Grid size={{ lg: 3, xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Contact Number<span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  value={productCompliancedata?.contactNumber}
                  name="contactNumber"
                  placeholder="Enter contactNumber"
                  disabled={inputDisble}
                  onChange={(e) =>
                    dispatch({ value: e?.target?.value, name: "contactNumber" })
                  }
                  error={productCompliancedata.contactNumberStatus === "error"}
                  success={
                    productCompliancedata.contactNumberStatus === "success"
                  }
                />
                {productCompliancedata.contactNumberStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Contact number can only be between 8 to 15 characters
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ lg: 3, xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Contract Start Date<span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  value={productCompliancedata?.contractStart}
                  type="date"
                  name="contractStart"
                  placeholder="Enter contractStart"
                  disabled={inputDisble}
                  onChange={(e) =>
                    dispatch({
                      value: e?.target?.value,
                      name: "contractStart",
                    })
                  }
                  inputProps={{
                    max: new Date().toISOString().split("T")[0], // max today
                  }}
                  error={
                    productCompliancedata.contractStartStatus === "error"
                      ? true
                      : false
                  }
                  success={
                    productCompliancedata.contractStartStatus === "success"
                      ? true
                      : false
                  }
                />
              </Grid>

              <Grid size={{ lg: 3, xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Contract End Date<span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  value={productCompliancedata?.contractEnd}
                  type="date"
                  name="contractStart"
                  placeholder="Enter contractStart"
                  disabled={inputDisble}
                  onChange={(e) =>
                    dispatch({
                      value: e?.target?.value,
                      name: "contractEnd",
                    })
                  }
                  inputProps={{
                    min: productCompliancedata?.contractStart || undefined, // min fromDate
                  }}
                  error={
                    productCompliancedata.contractEndStatus === "error"
                      ? true
                      : false
                  }
                  success={
                    productCompliancedata.contractEndStatus === "success"
                      ? true
                      : false
                  }
                />
              </Grid>

              <Grid size={{ lg: 3, xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Complete Within<span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  value={productCompliancedata?.completeWithin}
                  type="date"
                  name="completeWithin"
                  placeholder="Enter completeWithin"
                  disabled={inputDisble}
                  onChange={(e) =>
                    dispatch({
                      value: e?.target?.value,
                      name: "completeWithin",
                    })
                  }
                  error={
                    productCompliancedata.completeWithinStatus === "error"
                      ? true
                      : false
                  }
                  success={
                    productCompliancedata.completeWithinStatus === "success"
                      ? true
                      : false
                  }
                />
              </Grid>

              <Grid size={{ lg: 3, xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Agent <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="agentId"
                  value={productCompliancedata?.agentId}
                  customStyles={{ optionPadding: 20 }}
                  isDisabled={inputDisble}
                  options={allagentsOptions}
                  onChange={(e) =>
                    dispatch({
                      value: e,
                      name: "agentId",
                    })
                  }
                  error={
                    productCompliancedata.agentIdStatus === "error"
                      ? true
                      : false
                  }
                  success={
                    productCompliancedata.agentIdStatus === "success"
                      ? true
                      : false
                  }
                  isClearable
                />
              </Grid>

              <Grid size={{ lg: 4, xs: 5, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Address <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  multiline
                  rows={4}
                  value={productCompliancedata?.address}
                  name="address"
                  placeholder="Enter address"
                  disabled={inputDisble}
                  onChange={(e) =>
                    dispatch({
                      value: e?.target?.value,
                      name: "address",
                    })
                  }
                  error={
                    productCompliancedata.addressStatus === "error"
                      ? true
                      : false
                  }
                  success={
                    productCompliancedata.addressStatus === "success"
                      ? true
                      : false
                  }
                />
              </Grid>
            </Grid>
            <Grid
              size={{ xs: 12, md: 12, lg: 12 }}
              container
              spacing={1}
              sx={{ display: "flex", justifyContent: "flex-end" }}
            >
              {type != "view" && (
                <IconButton onClick={Addproducts}>
                  <AddCircleOutlinedIcon />
                </IconButton>
              )}
            </Grid>
            {productCompliancedata?.products.map((compliance, index) => (
              <Grid
                size={{ xs: 12, md: 12, lg: 12 }}
                container
                spacing={1}
                sx={{
                  border: "1px solid grey",
                  borderRadius: "20px",
                  marginTop: 1,
                  padding: "20px",
                }}
              >
                <Grid
                  size={{ xs: 12, md: 12, lg: 12 }}
                  sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                    margin: 0,
                  }}
                >
                  {type === "add" && (
                    <IconButton onClick={() => deleteproducts(index)}>
                      <DeleteOutlineOutlinedIcon />
                    </IconButton>
                  )}
                </Grid>

                <Grid size={{ lg: 4, xs: 12, sm: 4 }}>
                  <MaterialBox lineHeight={0} display="inline-block">
                    <MaterialTypography
                      component="label"
                      variant="caption"
                      fontWeight="bold"
                    >
                      Product <span style={{ color: "red" }}>*</span>
                    </MaterialTypography>
                  </MaterialBox>
                  <MaterialSelect
                    name="Product"
                    value={compliance.productId}
                    customStyles={{ optionPadding: 20 }}
                    isDisabled={inputDisble}
                    options={allProductsOptions}
                    menuPlacement="top"
                    onChange={(e) =>
                      dispatch({
                        value: e,
                        name: "products",
                        index,
                        field: "productId",
                      })
                    }
                    error={
                      compliance?.productIdStatus === "error" ? true : false
                    }
                    success={
                      compliance?.productIdStatus === "success" ? true : false
                    }
                  />
                </Grid>

                <Grid size={{ lg: 4, xs: 12, sm: 4 }}>
                  <MaterialBox lineHeight={0} display="inline-block">
                    <MaterialTypography
                      component="label"
                      variant="caption"
                      fontWeight="bold"
                    >
                      Quantity<span style={{ color: "red" }}>*</span>
                    </MaterialTypography>
                  </MaterialBox>
                  <MaterialInput
                    value={compliance.quantity}
                    type="number"
                    name="quantity"
                    placeholder="Enter quantity"
                    disabled={inputDisble}
                    onChange={(e) =>
                      dispatch({
                        value: e?.target?.value,
                        name: "products",
                        index,
                        field: "quantity",
                      })
                    }
                    error={compliance.quantityStatus === "error" ? true : false}
                    success={
                      compliance.quantityStatus === "success" ? true : false
                    }
                    onKeyDown={(e) => {
                      if (["e", "E", "+", "-"].includes(e.key)) {
                        e.preventDefault();
                      }
                    }}
                    sx={{
                      "& input::-webkit-inner-spin-button, & input::-webkit-outer-spin-button":
                      {
                        WebkitAppearance: "none",
                        margin: 0,
                      },
                      "& input": {
                        MozAppearance: "textfield",
                      },
                    }}
                  />
                </Grid>

                <Grid size={{ lg: 4, xs: 12, sm: 4 }}>
                  <MaterialBox lineHeight={0} display="inline-block">
                    <MaterialTypography
                      component="label"
                      variant="caption"
                      fontWeight="bold"
                    >
                      Product Category<span style={{ color: "red" }}>*</span>
                    </MaterialTypography>
                  </MaterialBox>
                  <MaterialInput
                    value={compliance.productCategory}
                    name="productCategory"
                    placeholder="Enter productCategory"
                    disabled={true}
                    onChange={(e) =>
                      dispatch({
                        value: e?.target?.value,
                        name: "products",
                        index,
                        field: "productCategory",
                      })
                    }
                    error={
                      compliance.productCategoryStatus === "error"
                        ? true
                        : false
                    }
                    success={
                      compliance.productCategoryStatus === "success"
                        ? true
                        : false
                    }
                  />
                </Grid>
              </Grid>
            ))}
          </MaterialBox>

          {type != "view" && (
            <MaterialBox
              display="flex"
              justifyContent="flex-end"
              alignItems="center"
            >
              <MaterialButton
                sx={{ m: 2 }}
                variant="gradient"
                color="dark"
                onClick={() => navigate("/product-compliance")}
              >
                Cancel
              </MaterialButton>
              <MaterialButton
                sx={{ m: 2 }}
                variant="gradient"
                color="dark"
                onClick={type == "add" ? handleSumbit : handleUpdate}
              >
                {type == "add" ? "Submit" : "update"}
              </MaterialButton>
            </MaterialBox>
          )}
        </CardContent>
      </Card>
    </DashboardLayout>
  );
};

export default ProductDisplayComplianceForm;
